import React, { Component } from 'react';
import ReactTable from 'react-table'
import history from '../../modules/History';
import { Button, notification } from 'antd';
import { END_POINT } from '../../constants/config';
import { getPagesList } from '../../modules/Api';
import ACL from '../../components/ACL';

class Pages  extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getPagesList((res) => {this.setState({
            items: res.data.data,
            last_page: res.data.last_page,
            count: res.data.total,
            pageSize: res.data.per_page
        })}, query);
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'id',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;
        this.fetchData(query);
    }
    //
    //removeCoupon(id) {
    //    const warningMessage = `آیا از حذف کوپن اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
    //    if (window.confirm(warningMessage)) {
    //        removeCouponItem(id, () => {
    //            notification.open({
    //                message: `کوپن با موفقیت حذف شد!`,
    //                description: `تمامی اطلاعات کوپن با موفقیت حذف شدند.`
    //            })
    //        });
    //        this.fetchData();
    //    }
    //}

    render(){
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: false,
            },
            {
                Header: 'عنوان',
                accessor: 'slug',
                filterable: true,
                Cell: (row) => (<ACL component="span" has_permission="pages_management|pages_edit" denied={() => {return row.original.slug;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                                      title={row.original.slug} onClick={() => {
                                        window.open(`/pages/edit/${row.original.slug}`, "_blank")
                                      }
                                      }> {row.original.slug} </span></ACL>)
            },
            {
                Header: 'نوع',
                accessor: 'type',
                filterable: false,
                Cell: (row) => (<span> {row.original.type == 1 ? 'Section' : 'Page'} </span>)
            }
        ];


        return(
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default Pages;


// WEBPACK FOOTER //
// ./src/containers/Pages/index.js